// ===============================
// 👉 INSERTAR BOTÓN "COMPRAR AHORA"
// ===============================
document.addEventListener("DOMContentLoaded", function () {

  function insertarBoton() {

    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const addBtn = form.querySelector('[type="submit"]');
    if (!addBtn) return;

    // evitar duplicados
    if (form.querySelector('.comprar-ahora-custom')) return;

    const btn = document.createElement('button');
    btn.type = "button";
    btn.className = "button comprar-ahora-custom";
    btn.innerText = "Comprar ahora";

    addBtn.insertAdjacentElement('afterend', btn);
  }

  // Horizon carga dinámico
  insertarBoton();
  setTimeout(insertarBoton, 300);
  setTimeout(insertarBoton, 800);
  setTimeout(insertarBoton, 1500);

});


// ===============================
// 👉 FUNCIONALIDAD BOTÓN
// ===============================
document.addEventListener("click", function (e) {

  const btn = e.target.closest('.comprar-ahora-custom');
  if (!btn) return;

  e.preventDefault();

  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const submitButton = form.querySelector('[type="submit"]');

  btn.disabled = true;
  btn.innerText = "Agregando...";

  if (submitButton) {
    submitButton.click();
  }

  // abrir carrito
  setTimeout(() => {

    const drawer =
      document.querySelector('cart-drawer-component') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }

    btn.disabled = false;
    btn.innerText = "Comprar ahora";

    // 🔥 REINICIAR FACTURACIÓN (CLAVE)
    initFactura();

  }, 700);

});


// ===============================
// 👉 FIX FACTURACIÓN (DEFINITIVO)
// ===============================
function initFactura() {

  const radios = document.querySelectorAll('input[name="attributes[tipo_cliente]"]');
  const fields = document.querySelector('#empresa_fields');

  if (!radios.length || !fields) return;

  // evitar duplicar eventos
  if (fields.dataset.facturaBound === "true") return;
  fields.dataset.facturaBound = "true";

  radios.forEach(radio => {

    radio.addEventListener('change', () => {

      if (radio.value === 'empresa' && radio.checked) {
        fields.style.display = 'block';
      }

      if (radio.value === 'persona' && radio.checked) {
        fields.style.display = 'none';
      }

    });

  });

}


// ===============================
// 👉 RE-EJECUTAR AUTOMÁTICO
// ===============================

// carga inicial
document.addEventListener("DOMContentLoaded", initFactura);

// cuando Shopify re-renderiza secciones
document.addEventListener("shopify:section:load", initFactura);
document.addEventListener("shopify:section:reorder", initFactura);

// fallback extra (por Horizon)
setInterval(() => {
  initFactura();
}, 1500);

// ===============================
// 🔥 VALIDACIÓN FACTURACIÓN PRO + RUT FORMATO CL
// ===============================

document.addEventListener('click', function(e){

  const btn = e.target.closest('button[name="checkout"]');
  if (!btn) return;

  const empresaRadio = document.querySelector('input[name="attributes[tipo_cliente]"][value="empresa"]');

  if (!empresaRadio || !empresaRadio.checked) return;

  const razon = document.querySelector('input[name="attributes[razon_social]"]');
  const rut = document.querySelector('input[name="attributes[rut]"]');
  const direccion = document.querySelector('input[name="attributes[direccion_empresa]"]');

  // ===============================
  // 🔥 VALIDAR CAMPOS OBLIGATORIOS
  // ===============================
  if (
    !razon?.value.trim() ||
    !rut?.value.trim() ||
    !direccion?.value.trim()
  ) {
    e.preventDefault();
    alert("Debes completar Razón Social, RUT y Dirección.");
    return;
  }

  const rutValue = rut.value.trim();

  // ===============================
  // 🔥 VALIDAR FORMATO RUT
  // ===============================
  const rutRegex = /^(\d{1,2}\.\d{3}\.\d{3}-[\dkK]|\d{7,8}-[\dkK])$/;

  if (!rutRegex.test(rutValue)) {
    e.preventDefault();
    alert("Formato de RUT inválido. Usa 12.345.678-9 o 12345678-9");
    return;
  }

  // ===============================
  // 🔥 VALIDAR DÍGITO VERIFICADOR
  // ===============================
  function validarRUT(rutCompleto) {

    rutCompleto = rutCompleto.replace(/\./g, '').replace('-', '');

    let cuerpo = rutCompleto.slice(0, -1);
    let dv = rutCompleto.slice(-1).toUpperCase();

    let suma = 0;
    let multiplo = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += multiplo * cuerpo.charAt(i);
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    let dvEsperado = 11 - (suma % 11);
    dvEsperado = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();

    return dv === dvEsperado;
  }

  if (!validarRUT(rutValue)) {
    e.preventDefault();
    alert("El RUT ingresado no es válido.");
    return;
  }

});